/**
 * Formats a time string (from server or user input) to 'HH:mm'.
 * Handles formats: 'HH:mm:ss.SSS', 'HH:mm:ss', and 'HH:mm'.
 * Returns an empty string if the input is invalid or cannot be parsed.
 *
 * @param {string} timeString - The time string to format.
 * @returns {string} The formatted time in 'HH:mm' or an empty string if invalid.
 */
import { format, parse } from "date-fns";
import { TIME_FORMAT } from "@/constants";

export function formatTimeHHMM(timeString: string): string {
  if (!timeString) return "";

  let date = parse(timeString, "HH:mm:ss.SSS", new Date());
  if (isNaN(date.getTime())) {
    date = parse(timeString, "HH:mm:ss", new Date());
  }
  if (isNaN(date.getTime())) {
    date = parse(timeString, TIME_FORMAT, new Date());
  }
  if (isNaN(date.getTime())) {
    return "";
  }
  return format(date, TIME_FORMAT);
}
